import React, { useState, useEffect } from 'react';
import { settingService } from '../../services/settingService';
import { useSite } from '../../context/SiteContext';

const EMPTY_FORM = {
  jobs_default_email: '',
  jobs_default_phone: '',
  contact_email: '',
  contact_address: '',
  contact_phone_cskh: '',
  contact_phone_hr: '',
  csr_tu_thuoc: '',
  csr_diem_truong: '',
  csr_em_nho: ''
};

export default function SettingsManager() {
  const { refreshSettings } = useSite();
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    settingService
      .getAll()
      .then((res) => {
        if (res.data?.map) {
          setFormData((prev) => ({ ...prev, ...res.data.map }));
        }
      })
      .catch((err) => alert(err.message))
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setErrorMsg('');
    try {
      await settingService.updateSettings(formData);
      refreshSettings();
    } catch (err) {
      setErrorMsg('Lỗi lưu: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="admin-panel">
      <div className="panel-head">
        <div>
          <h2>Cài đặt chung</h2>
          <p className="panel-head__sub">
            Cấu hình global cho site — địa chỉ VP, email/hotline mặc định, số liệu CSR. Đổi 1 chỗ → toàn bộ site tự sync.
          </p>
        </div>
        <button type="submit" form="settingsForm" className="btn btn--primary" disabled={loading || saving}>
          {saving ? 'Đang lưu…' : 'Lưu cài đặt'}
        </button>
      </div>

      {loading ? (
        <p className="muted">Đang tải…</p>
      ) : (
        <form id="settingsForm" className="admin-form" style={{ maxWidth: '780px' }} onSubmit={handleSubmit}>
          <div className="field-row">
            <label className="field">
              <span className="field__label">Email ứng tuyển HR</span>
              <input type="email" name="jobs_default_email" value={formData.jobs_default_email} onChange={handleChange} placeholder="tuyendung@thethaopharma.vn" />
              <small className="hint">Hiện ở footer JD modal.</small>
            </label>
            <label className="field">
              <span className="field__label">Hotline / Zalo HR</span>
              <input type="text" name="jobs_default_phone" value={formData.jobs_default_phone} onChange={handleChange} placeholder="0989.729.095" />
            </label>
          </div>
          <div className="field-row">
            <label className="field">
              <span className="field__label">Email liên hệ (footer)</span>
              <input type="email" name="contact_email" value={formData.contact_email} onChange={handleChange} placeholder="thethaoltd@gmail.com" />
            </label>
            <label className="field">
              <span className="field__label">Địa chỉ văn phòng</span>
              <input type="text" name="contact_address" value={formData.contact_address} onChange={handleChange} placeholder="60B Nguyễn Huy Tưởng, P. Thanh Xuân, Hà Nội" />
            </label>
          </div>
          <div className="field-row">
            <label className="field">
              <span className="field__label">Hotline CSKH</span>
              <input type="text" name="contact_phone_cskh" value={formData.contact_phone_cskh} onChange={handleChange} placeholder="0866863865" />
            </label>
            <label className="field">
              <span className="field__label">Hotline HR (footer)</span>
              <input type="text" name="contact_phone_hr" value={formData.contact_phone_hr} onChange={handleChange} placeholder="0989729095" />
            </label>
          </div>
          <div className="field-row">
            <label className="field">
              <span className="field__label">Tủ thuốc cho em — Số tủ thuốc</span>
              <input type="text" name="csr_tu_thuoc" value={formData.csr_tu_thuoc} onChange={handleChange} placeholder="425" />
            </label>
            <label className="field">
              <span className="field__label">Số điểm trường</span>
              <input type="text" name="csr_diem_truong" value={formData.csr_diem_truong} onChange={handleChange} placeholder="425" />
            </label>
          </div>
          <div className="field-row">
            <label className="field">
              <span className="field__label">Số em nhỏ tiếp cận y tế</span>
              <input type="text" name="csr_em_nho" value={formData.csr_em_nho} onChange={handleChange} placeholder="23671" />
            </label>
          </div>
          {errorMsg && <p className="form-alert" role="alert">{errorMsg}</p>}
        </form>
      )}
    </section>
  );
}
